import { z } from 'zod';
import { courseSummarySchema } from './course.js';
import { courseLevelSchema, identifierSchema } from './common.js';
/**
 * Pathways — curated bundles that are licensed products in their own right, with their own ISBN.
 */
export const pathwaySummarySchema = z.object({
    id: z.string(),
    code: z.string(),
    isbn: z.string().nullable(),
    name: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    levelMin: courseLevelSchema.nullable(),
    levelMax: courseLevelSchema.nullable(),
    durationSeconds: z.number().int().nullable(),
    /** Every listed member, resolved or not. */
    courseCount: z.number().int(),
    /** Members that resolved to a licensed course. The gap between the two is the interesting bit. */
    resolvedCourseCount: z.number().int(),
});
/**
 * One entry in a pathway's ordered curriculum.
 *
 * The source lists members as free text (`"<Title> by <Author>"`) with no ISBN, and some never
 * matched a licensed product. Those are returned with `resolved: false` and their verbatim
 * `rawTitle` so the gap is visible on the page, rather than being dropped and making a
 * seven-course pathway silently render as five.
 */
export const pathwayMemberSchema = z.object({
    position: z.number().int(),
    rawTitle: z.string(),
    resolved: z.boolean(),
    course: courseSummarySchema.nullable(),
});
export const pathwayDetailSchema = pathwaySummarySchema.extend({
    objectives: z.array(z.string()),
    mainSkills: z.array(z.string()),
    durationRaw: z.string().nullable(),
    courses: z.array(pathwayMemberSchema),
});
export const pathwayListResponseSchema = z.object({
    items: z.array(pathwaySummarySchema),
});
export const pathwayIdParamSchema = z.object({ idOrSlug: identifierSchema });
//# sourceMappingURL=pathway.js.map